import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

export async function getProjects() {
  const { data } = await axios.get(`${API}/projects`);
  return data;
}

export async function getProject(id) {
  const { data } = await axios.get(`${API}/projects/${id}`);
  return data;
}

export async function createProject(payload) {
  const { data } = await axios.post(`${API}/projects`, payload);
  return data;
}

export async function updateProject(id, payload) {
  const { data } = await axios.put(`${API}/projects/${id}`, payload);
  return data;
}

export async function deleteProject(id) {
  await axios.delete(`${API}/projects/${id}`);
}